import { useCurrentMedication } from '@/hooks/useCurrentMedication'
import MedicationRequestChip from '../med-request-chip'
import Lock2 from '@/components/ui/icons/lock2'
import { useLockedFamilyIds } from '@/services/useLockItem'
import type { ReadOnlyReason } from '@/lib/med-requests'

/** The read-only banner shows only when nothing on the page is actionable (see readOnlyReasonOf). */
const Header = ({ readOnlyReason }: { readOnlyReason: ReadOnlyReason | null }) => {
  const medRequest = useCurrentMedication()
  const data = medRequest?.data
  const isFamilyLocked = useLockedFamilyIds(data?.id ?? '').length > 0

  if (!data) return null

  return (
    <>
      {data.locked && (
        <div className='flex items-center rounded-2xl border border-[#FF8080] bg-[#FFF2F2] gap-4 px-6 py-4'>
          <Lock2 />
          <p className='text-[#080F30] font-poppins text-base font-normal leading-[170%]'>
            This medication request is currently{' '}
            <span className='font-semibold'>LOCKED BY {data.locked?.split(':')[1]}</span>. You can't make any changes to
            it at the moment.
          </p>
        </div>
      )}
      {!data.locked && isFamilyLocked && (
        <div className='flex items-center rounded-2xl border border-[#FF8080] bg-[#FFF2F2] gap-4 px-6 py-4'>
          <Lock2 />
          <p className='text-[#080F30] font-poppins text-base font-normal leading-[170%]'>
            Another item of this order is currently <span className='font-semibold'>LOCKED</span> by another user. You
            can't make a decision until they close it.
          </p>
        </div>
      )}
      {readOnlyReason && (
        <div className='mb-20 rounded-2xl border border-[#E9EAED] bg-[#FFFAEB] py-4 px-6'>
          <p className='text-[#080F30] leading-[170%]'>
            {readOnlyReason === 'awaiting-items' ? (
              <>
                Not every item of this order is in <b>Clinical Review</b>. This page is <b>read-only</b> until they all
                are.
              </>
            ) : (
              <>
                You are viewing a <b>PREVIOUS</b> medication request. This page is <b>read-only</b> and cannot be
                edited.
              </>
            )}
          </p>
        </div>
      )}
      <MedicationRequestChip />
    </>
  )
}

export default Header
